const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "activityNotice":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "activityNotice",
    reducer: reducer,
};

export default data;